import React, { 
	//useRef, 
	useEffect, useState,
	//useState 
} from "react";
import { connect } from "react-redux";

import { CalciteBlock, CalciteButton, 
	//CalciteInput, 
	//CalciteNotice,
	CalcitePanel,
CalciteSelect,
CalciteOption,
CalciteStepper,
CalciteStepperItem,
CalciteLabel
} from "@esri/calcite-components-react";
import {loadGraphingSelectOptions,} from '../../../../../Flux/thunks';

import keys from "../../../Layers/RSSBP/shellfish/keys";
//import * as watchUtils from "@arcgis/core/core/watchUtils";
//import {GenerateUrlOptions, CreateUrlFromUrlOptions} from '../../Logic/UrlOptionsLogic';

const ReportBlock = ({graphingOptions, initGraphOptions}) => {
	const [reportUrl, SetReportUrl] = useState(`${process.env.REACT_APP_REPORT_URL}/`);
	const [dataOptions, SetDataOptions] = useState({

		state: '',
		region: '',
		subregion: '',

		stateCompare: '',
		regionCompare: '',
		subregionCompare: '',

		speciesKey: '',
		pathogenKey: '',
		dataTimeframe: '',
	});
	

	const UpdateStateOption = (_e) => {
		SetDataOptions({
			...dataOptions,
			state: _e.target.selectedOption.value,
			region: '',
			subregion: ''
		});
	}
	const UpdateRegionOption = (_e) => {
		SetDataOptions({
			...dataOptions,
			region: _e.target.selectedOption.value,
			subregion: ''
		});
	}
/*
	const UpdateSubRegionOption = (_e) => {
		SetDataOptions({
			...dataOptions,
			subregion: _e.target.selectedOption.value
		});
	}
*/

	const UpdatePathogenOption = (_e) => {
		SetDataOptions({
			...dataOptions,
			pathogenKey: _e.target.selectedOption.value,
		});
	}
	const UpdateSpeciesOption = (_e) => {
		SetDataOptions({
			...dataOptions,
			speciesKey: _e.target.selectedOption.value,
		});
	}
	const UpdateDataTimeframe = (_e) => {
		SetDataOptions({
			...dataOptions,
			dataTimeframe: _e.target.selectedOption.value,
		});
	}

	//comparison
	const ResetComarison = (_e) => {
		SetDataOptions({
			...dataOptions,
			stateCompare: '',
			regionCompare: '',
			subregionCompare: ''
		});
	}
	const UpdateStateCompareOption = (_e) => {
		SetDataOptions({
			...dataOptions,
			stateCompare: _e.target.selectedOption.value,
			regionCompare: '',
			subregionCompare: ''
		});
	}
	const UpdateRegionCompareOption = (_e) => {
		SetDataOptions({
			...dataOptions,
			regionCompare: _e.target.selectedOption.value,
			subregionCompare: ''
		});
	}
/*
	const UpdateSubRegionCompareOption = (_e) => {
		SetDataOptions({
			...dataOptions,
			subregionCompare: _e.target.selectedOption.value
		});
	}
*/

	
	const DisplayChoicesPreviouslyMade = () => {
		const createLi = [];
		if( dataOptions.state ) {
			createLi.push(`State: ${dataOptions.state}`);
		}else{
			createLi.push(`State: All States`);
		}
		if( dataOptions.region ) {
			createLi.push(`Region: ${dataOptions.region}`);
		}else{
			createLi.push(`Region: All Regions`);
		}
/*
		if( dataOptions.subregion ) {
			createLi.push(`Subregion: ${dataOptions.subregion}`);
		}else{
			createLi.push(`Subregion: All Subregions`);
		}
		*/
		if( dataOptions.stateCompare ) {
				//const CompareUl = document.createElement('ul');
				const CompareUlLis = [];
				if( dataOptions.stateCompare ) {
					CompareUlLis.push(<li>State: {dataOptions.stateCompare}</li>);
				}
				
				if( dataOptions.regionCompare ) {
					CompareUlLis.push(<li>Region: {dataOptions.regionCompare}</li>);
				}else{
					CompareUlLis.push(<li>Region: All Regions</li>);
				}
		/*
				if( dataOptions.subregionCompare ) {
					CompareUlLis.push(<li>Subregion: {dataOptions.subregionCompare}</li>);
				}else{
					CompareUlLis.push(<li>Subregion: All Subregions</li>);
				}
				*/
			
			createLi.push(<>Compared against <ul>{CompareUlLis.map( (item,key) => { return item; })}</ul></>);
		}


		if( dataOptions.speciesKey ){
			createLi.push(`Species: ${keys.species[dataOptions.speciesKey].name}`);
		}
		if( dataOptions.pathogenKey ){
			createLi.push(`Pathogen: ${keys.pathogens[dataOptions.pathogenKey].name}`);
		}
		if( dataOptions.dataTimeframe ){
			switch(dataOptions.dataTimeframe) {
				case 'all':
					createLi.push(`Timeframe: All Data`);
					break;
				case 'past-three':
					createLi.push(`Timeframe: Past Three Years`);
					break;
				case 'page-five':
					createLi.push(`Timeframe: Past Five Years`);
					break;
				default:
					break;
			}
		}
		
		return( 
			<ul>
				{createLi.map( (liItem, key) => { return <li key={key}>{liItem}</li>})}
			</ul>
		)
	}
	


	const TempReportCreation = () => {


	}

	useEffect( () =>{
		initGraphOptions();
	}, [initGraphOptions] );
	
	/*
	<CalciteNotice active={true} color="red" icon="exclamation-mark-triangle-f" style={{marginBottom:'1em'}}>
	<div slot="title">Data In Reports</div>
	<div slot="message">This feature is still under development in the new format and some data items may not be available.</div>
</CalciteNotice>
*/
	return (
		<CalciteBlock 
		heading="Generate Report"
		summary="Generate Report from options"
		collapsible={true}
		>
			<CalcitePanel>
				<CalciteStepper layout="vertical" scale="s" icon={true}>
					<CalciteStepperItem className="no-outline" 
					itemTitle="Location" itemSubtitle="Select the area you want to look at." 
					complete={dataOptions.state || null}>
						<CalciteLabel>
							State: 
							<CalciteSelect label="State" name="state" scale="m" onCalciteSelectChange={UpdateStateOption}>
								<CalciteOption value={''} label="- Select A State -" selected={!dataOptions.state}></CalciteOption>
								{Object.keys(graphingOptions.controlOptions).map( (stateName, key) =>{
									return (<CalciteOption key={key} value={stateName} selected={dataOptions.state === stateName}>{stateName}</CalciteOption>);
								})}
							</CalciteSelect>
						</CalciteLabel>
						<CalciteLabel disabled={!dataOptions.state || null} >
							Region: 
							<CalciteSelect label="Region" name="region" scale="m" onCalciteSelectChange={UpdateRegionOption}>
								<CalciteOption value={''} label="- All Regions -" selected={!dataOptions.region}></CalciteOption>
								{
									dataOptions.state 
									? Object.keys(graphingOptions.controlOptions[dataOptions.state]).map( (regionName, key) =>{
										return (<CalciteOption key={key} value={regionName} selected={dataOptions.region === regionName} label={regionName}></CalciteOption>);
									}) : null
								}	
							</CalciteSelect>
						</CalciteLabel>
						{/*
						<CalciteLabel disabled={!dataOptions.state || !dataOptions.region || null} >
							Sub-region: 
							<CalciteSelect label="Sub-region" name="sub-region" scale="m" onCalciteSelectChange={UpdateSubRegionOption}>
								<CalciteOption value={''} label="- All Sub-regions -" selected={!dataOptions.subregion}></CalciteOption>
								{
									dataOptions.state && dataOptions.region
									? Object.keys(graphingOptions.controlOptions[dataOptions.state][dataOptions.region]).map( (subregionName, key) =>{
										return (<CalciteOption key={key} value={subregionName} selected={dataOptions.subregion === subregionName} label={subregionName}></CalciteOption>);
									}) : null
								}	
							</CalciteSelect>
						</CalciteLabel>
						*/}
					</CalciteStepperItem>
					<CalciteStepperItem className="no-outline" 
					itemTitle="Compare Location" itemSubtitle="(Optional) Select a location to compare to." 
					disabled={!dataOptions.state || null}
					complete={dataOptions.stateCompare || null}>
						<CalciteButton width="full" onClick={() => {
							ResetComarison()
						}}>Clear Comparison</CalciteButton>
						<CalciteLabel>
							State: 
							<CalciteSelect label="State" name="state" scale="m" onCalciteSelectChange={UpdateStateCompareOption}>
								<CalciteOption value={''} label="- No Comparison -" selected={!dataOptions.stateCompare}></CalciteOption>
								{Object.keys(graphingOptions.controlOptions).map( (stateName, key) =>{
									return (<CalciteOption key={key} value={stateName} selected={dataOptions.stateCompare === stateName}>{stateName}</CalciteOption>);
								})}
							</CalciteSelect>
						</CalciteLabel>
						<CalciteLabel disabled={!dataOptions.stateCompare || null} >
							Region: 
							<CalciteSelect label="Region" name="region" scale="m" onCalciteSelectChange={UpdateRegionCompareOption}>
								<CalciteOption value={''} label="- All Regions -" selected={!dataOptions.regionCompare}></CalciteOption>
								{
									dataOptions.stateCompare 
									? Object.keys(graphingOptions.controlOptions[dataOptions.stateCompare]).map( (regionName, key) =>{
										return (<CalciteOption key={key} value={regionName} selected={dataOptions.regionCompare === regionName} label={regionName}></CalciteOption>);
									}) : null
								}	
							</CalciteSelect>
						</CalciteLabel>
						{/*
						<CalciteLabel disabled={!dataOptions.stateCompare || !dataOptions.regionCompare || null} >
							Sub-region: 
							<CalciteSelect label="Sub-region" name="sub-region" scale="m" onCalciteSelectChange={UpdateSubRegionCompareOption}>
								<CalciteOption value={''} label="- All Sub-regions -" selected={!dataOptions.subregionCompare}></CalciteOption>
								{
									dataOptions.stateCompare && dataOptions.regionCompare
									? Object.keys(graphingOptions.controlOptions[dataOptions.stateCompare][dataOptions.regionCompare]).map( (subregionName, key) =>{
										return (<CalciteOption key={key} value={subregionName} selected={dataOptions.subregionCompare === subregionName} label={subregionName}></CalciteOption>);
									}) : null
								}	
							</CalciteSelect>
						</CalciteLabel>
						*/}
					</CalciteStepperItem>
					<CalciteStepperItem 

						className="no-outline"
						disabled={null}
						complete={dataOptions.pathogen || dataOptions.species || null }
						itemTitle="Species / Pathogen" itemSubtitle="(Optional) Choose a species, pathogen and / or timeframe">
	{/* Species should filter pathogen drop down */}
						<CalciteLabel>
							Species: 
							<CalciteSelect label="Species" name="species" scale="m" onCalciteSelectChange={UpdateSpeciesOption}>
								<CalciteOption value={''} label="- All Species -" selected={!dataOptions.species}></CalciteOption>
								{
									keys.availableCurrentData
									.map( (bySpeciesData, key) =>{
										return (<CalciteOption key={key} value={bySpeciesData.speciesKey} 
											selected={dataOptions.speciesKey === bySpeciesData.speciesKey} label={
												`${keys.species[bySpeciesData.speciesKey].name} (${keys.species[bySpeciesData.speciesKey].sciName})`
											}></CalciteOption>);
									}) 
								}	
							</CalciteSelect>
						</CalciteLabel>
						<CalciteLabel>
							Pathogen: 
							<CalciteSelect label="Pathogen" name="pathogen" scale="m" onCalciteSelectChange={UpdatePathogenOption}>
								<CalciteOption value={''} label="- All Pathogens -" selected={!dataOptions.pathogen}></CalciteOption>
								{
								[...new Set(keys.availableCurrentData
									.filter( (bySpeciesData) => {
										if( !dataOptions.speciesKey ) {
											return true;
										}

										return bySpeciesData.speciesKey === dataOptions.speciesKey;
									}) 
									.flatMap( (bySpeciesData, key) =>{
											return bySpeciesData.pathogenKeys.map( (pathogenKey, subKey) => {
												return (<CalciteOption key={subKey+key} value={pathogenKey} 
													selected={dataOptions.pathogenKey === pathogenKey} label={
														`${keys.pathogens[pathogenKey].name}`
													}></CalciteOption>);
											})
								}) )] 
								
								
								/*
									GetAvailablepathogens()
									.map( (pathogen, key) =>{
										return (<CalciteOption key={key} value={pathogen} selected={dataOptions.pathogen === pathogen} label={pathogen}></CalciteOption>);
									})
								*/}	
							</CalciteSelect>
						</CalciteLabel>
						<CalciteLabel>
							Data Timeframe: 
							<CalciteSelect label="Data Comparison Timeframe" name="dataTimeframe" scale="m" onCalciteSelectChange={UpdateDataTimeframe}>
								<CalciteOption value={'all'} label="- All Data Available -" selected={!dataOptions.dataTimeframe || dataOptions.dataTimeframe === 'all'}></CalciteOption>
								<CalciteOption value={'past-three'} label="Last 3 Years of Data" selected={dataOptions.dataTimeframe === 'past-three'}></CalciteOption>
								<CalciteOption value={'past-five'} label="Last 5 Years of Data" selected={dataOptions.dataTimeframe === 'past-five'}></CalciteOption>
							</CalciteSelect>
						</CalciteLabel>
					</CalciteStepperItem>
					<CalciteStepperItem 
						className="no-outline"
						disabled={!dataOptions.state || null}
						itemTitle="Review" itemSubtitle="Confirm choices">
						{DisplayChoicesPreviouslyMade()}
						<form target="_blank" method="post" action={reportUrl}>
							<input type="hidden" name="action" value="generateReport" />
							<input type="hidden" id="reportType" name="reportType" value={dataOptions.stateCompare ? 'compare' : 'single'} />

							<input type="hidden" name="reportStateMain" value={dataOptions.state} />
							<input type="hidden" name="reportRegionMain" value={dataOptions.region} />
							<input type="hidden" name="reportSubregionMain" value={dataOptions.subregion} />
							
							<input type="hidden" name="reportStateCompare" value={dataOptions.stateCompare} />
							<input type="hidden" name="reportRegionCompare" value={dataOptions.regionCompare} />
							<input type="hidden" name="reportSubregionCompare" value={dataOptions.subregionCompare} />
							
							<input type="hidden" name="species" value={dataOptions.speciesKey ? keys.species[dataOptions.speciesKey].name : ''} />
							<input type="hidden" name="pathogen" value={dataOptions.pathogenKey ? keys.pathogens[dataOptions.pathogenKey].name : ''} />
							<input type="hidden" name="dataTimeframe" value={dataOptions.dataTimeframe} />
							<CalciteButton  onClick={(_e) => {
								TempReportCreation();
							}} iconStart="file-report" type="submit"> Create Report </CalciteButton>
							{ (process.env.NODE_ENV === 'development' ?
								<>

								<div>
									<CalciteButton onClick={(_e) => {
										SetReportUrl(`https://mosaic.njaes.rutgers.edu/shellfish-api/report/`);
									}} type="button">Toggle Report Url</CalciteButton>
								</div>
								<p>
									{reportUrl}
								</p>
								</>
								: null
							) }
						</form>
					</CalciteStepperItem>
				</CalciteStepper>
			</CalcitePanel>
		</CalciteBlock>
	);
}

const mapStateToProps = (state) => ({
	graphingOptions: state.graphingOptions
});
// what actions are we allowed to use
const mapDispatchToProps = (dispatch) => ({
	initGraphOptions: () => {dispatch(loadGraphingSelectOptions())},
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportBlock);
